import React from 'react';
import { AD_RESERVED_CLASS } from '@benzinga/ads-utils';
import { FreestarAd } from './Freestar/FreestarAd';

export const DefaultAdHeader: React.FC = () => {
  return (
    <div
      className={`${AD_RESERVED_CLASS} w-full flex items-center justify-center min-h-[90px] max-h-[90px]`}
      data-placement="top_header"
    >
      <FreestarAd className="overflow-hidden h-full" placement="top_header" />
    </div>
  );
};
